/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ProjectHistoryFragment = {
  __typename: "ProjectHistory"
  id: string
  links: {
    __typename: "ProjectHistoryLinks"
    prev?: string | null
    next?: string | null
  }
  entries: Array<{
    __typename: "ProjectHistoryEntry"
    id: string
    action: string
    timestamp: string
    label?: string | null
    entityType: string
    changes?: Array<{
      __typename: "ProjectHistoryChange"
      field: string
      newValue?: string | null
      oldValue?: string | null
    }> | null
    entity: {
      __typename: "ProjectHistoryEntity"
      id: string
      label?: string | null
      type: string
      displayPosition?: string | null
      variantKey?: string | null
    }
    fromEntity: {
      __typename: "ProjectHistoryEntity"
      id: string
      label?: string | null
      type: string
      displayPosition?: string | null
      variantKey?: string | null
    }
    toEntity: {
      __typename: "ProjectHistoryEntity"
      id: string
      label?: string | null
      type: string
      displayPosition?: string | null
      variantKey?: string | null
    }
    project: {
      __typename: "ProjectHistoryProject"
      id: string
      title?: string | null
      type: string
    }
    user: {
      __typename: "ProjectHistoryUser"
      id: string
      name?: string | null
      email?: string | null
      type: string
    }
  }>
}

export type ProjectHistoryEntryFragment = {
  __typename: "ProjectHistoryEntry"
  id: string
  action: string
  timestamp: string
  label?: string | null
  entityType: string
  changes?: Array<{
    __typename: "ProjectHistoryChange"
    field: string
    newValue?: string | null
    oldValue?: string | null
  }> | null
  entity: {
    __typename: "ProjectHistoryEntity"
    id: string
    label?: string | null
    type: string
    displayPosition?: string | null
    variantKey?: string | null
  }
  fromEntity: {
    __typename: "ProjectHistoryEntity"
    id: string
    label?: string | null
    type: string
    displayPosition?: string | null
    variantKey?: string | null
  }
  toEntity: {
    __typename: "ProjectHistoryEntity"
    id: string
    label?: string | null
    type: string
    displayPosition?: string | null
    variantKey?: string | null
  }
  project: {
    __typename: "ProjectHistoryProject"
    id: string
    title?: string | null
    type: string
  }
  user: {
    __typename: "ProjectHistoryUser"
    id: string
    name?: string | null
    email?: string | null
    type: string
  }
}

export type ProjectHistoryChangeFragment = {
  __typename: "ProjectHistoryChange"
  field: string
  newValue?: string | null
  oldValue?: string | null
}

export type ProjectHistoryUserFragment = {
  __typename: "ProjectHistoryUser"
  id: string
  name?: string | null
  email?: string | null
  type: string
}

export type ProjectHistoryProjectFragment = {
  __typename: "ProjectHistoryProject"
  id: string
  title?: string | null
  type: string
}

export type ProjectHistoryEntityFragment = {
  __typename: "ProjectHistoryEntity"
  id: string
  label?: string | null
  type: string
  displayPosition?: string | null
  variantKey?: string | null
}

export const ProjectHistoryChangeFragmentDoc = gql`
  fragment ProjectHistoryChange on ProjectHistoryChange {
    field
    newValue
    oldValue
  }
`
export const ProjectHistoryEntityFragmentDoc = gql`
  fragment ProjectHistoryEntity on ProjectHistoryEntity {
    id
    label
    type
    displayPosition
    variantKey
  }
`
export const ProjectHistoryProjectFragmentDoc = gql`
  fragment ProjectHistoryProject on ProjectHistoryProject {
    id
    title
    type
  }
`
export const ProjectHistoryUserFragmentDoc = gql`
  fragment ProjectHistoryUser on ProjectHistoryUser {
    id
    name
    email
    type
  }
`
export const ProjectHistoryEntryFragmentDoc = gql`
  fragment ProjectHistoryEntry on ProjectHistoryEntry {
    id
    action
    timestamp
    label
    entityType
    changes @type(name: "ProjectHistoryChange") {
      ...ProjectHistoryChange
    }
    entity @type(name: "ProjectHistoryEntity") {
      ...ProjectHistoryEntity
    }
    fromEntity @type(name: "ProjectHistoryEntity") {
      ...ProjectHistoryEntity
    }
    toEntity @type(name: "ProjectHistoryEntity") {
      ...ProjectHistoryEntity
    }
    project @type(name: "ProjectHistoryProject") {
      ...ProjectHistoryProject
    }
    user @type(name: "ProjectHistoryUser") {
      ...ProjectHistoryUser
    }
  }
  ${ProjectHistoryChangeFragmentDoc}
  ${ProjectHistoryEntityFragmentDoc}
  ${ProjectHistoryProjectFragmentDoc}
  ${ProjectHistoryUserFragmentDoc}
`
export const ProjectHistoryFragmentDoc = gql`
  fragment ProjectHistory on ProjectHistory {
    id
    links @type(name: "ProjectHistoryLinks") {
      prev
      next
    }
    entries @type(name: "ProjectHistoryEntry") {
      ...ProjectHistoryEntry
    }
  }
  ${ProjectHistoryEntryFragmentDoc}
`
